import React, { useState } from 'react'
import './admin-page.scss'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import AllianceLogo from '../../../assets/images/alliance-logo.png'
import { RiTeamLine, RiTeamFill } from "react-icons/ri";
import { setAdminActivePage } from '../../../redux/features/user/systemSlice'
import { getUserProfileImagePath } from '../../../assets/javascript/find-helpers'
import { controllerCalenderTypes, ui_version } from '../../../assets/javascript/const-data'
import {  TbLayoutList, TbLayoutListFilled, TbLayoutSidebarLeftCollapseFilled, TbLayoutSidebarLeftExpandFilled } from 'react-icons/tb'
import { BiBookBookmark, BiSolidBookBookmark } from "react-icons/bi";
import { HiHome, HiOutlineHome } from 'react-icons/hi'
import { IoMdLogOut } from 'react-icons/io'
import { IoCalendarNumberOutline, IoCalendarNumber } from "react-icons/io5";
import { MdOutlineAutoGraph } from 'react-icons/md'


function AdminPage({ pageHead, children }) {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { adminActivePage } = useSelector((state) => state.systemInfo)
    const { user } = useSelector((state) => state.userAuth)
    const userProfileImage = getUserProfileImagePath(user?.first_name);
    const [navActive, setNavActive] = useState(false)

    const clickMenuItem = (url, page) => {
        dispatch(setAdminActivePage(page))
        navigate(url || '/admin')
    }

    return (

        <div className={`admin-page-body ${navActive && "semi-nav-active"}`}>

            <div className="admin-body-section">
                <div className="admin-body">
                    <div className="title-section">
                        <div className="left">
                            <div className="title">
                                {navActive
                                    ? <TbLayoutSidebarLeftCollapseFilled onClick={() => setNavActive(!navActive)} />
                                    : <TbLayoutSidebarLeftExpandFilled onClick={() => setNavActive(!navActive)} />
                                }
                                <h3>{pageHead?.title}</h3>
                            </div>
                            <p>{pageHead?.desc}</p>
                        </div>
                        <div className="right">
                            {pageHead?.right}
                        </div>
                    </div>
                    <div className="body-content-div">
                        {children}
                    </div>
                </div>
            </div>

            <div className="nav-div">
                <div className="nav-sub-div">
                    <div className="title-section">
                        <div className="logo-section">
                            <div className="image-div">
                                <img src={AllianceLogo} alt='logo' />
                            </div>
                            <div className='head-text'>
                                <h3>Alliance</h3>
                                <p>Sales Controller App</p>
                            </div>
                        </div>
                    </div>
                    <div className="content-div">
                        <div className="menu-item-list">
                            {/* home */}
                            <div className={adminActivePage === 'home' ? "menu-item active-menu" : "menu-item"}
                                onClick={() => clickMenuItem('/controller', 'home')}>
                                {adminActivePage === 'home' ? <HiHome /> : <HiOutlineHome />}
                                <span>Home</span>
                            </div>

                            {user?.allowed_origins?.some(access => ['slcr_stfLst_write', 'slcr_stfLst_read'].includes(access)) &&
                                <div className={adminActivePage === 'sales_team' ? "menu-item active-menu" : "menu-item"}
                                    onClick={() => clickMenuItem('/controller/sales-team', 'sales_team')}>
                                    {adminActivePage === 'sales_team' ? <RiTeamFill /> : <RiTeamLine />}
                                    <span>Sales Team</span>
                                </div>}

                            {user?.allowed_origins?.some(access => ['slcr_inList_read', 'slcr_eqList_read', 'slcr_leList_read', 'slcr_inList_write', 'slcr_eqList_write', 'slcr_leList_write'].includes(access)) &&
                                <div className={adminActivePage === 'les_list' ? "menu-item active-menu" : "menu-item"}
                                    onClick={() => clickMenuItem(
                                        `/controller/les_list`,
                                        'les_list'
                                    )}>
                                    {adminActivePage === 'les_list' ? <TbLayoutListFilled /> : <TbLayoutList />}
                                    <span>LES List</span>
                                </div>}

                            {user?.allowed_origins?.some(access => ['slcr_inList_read', 'slcr_eqList_read', 'slcr_leList_read', 'slcr_inList_write', 'slcr_eqList_write', 'slcr_leList_write'].includes(access)) &&
                                <div className={adminActivePage === 'reports' ? "menu-item active-menu" : "menu-item"}
                                    onClick={() => clickMenuItem(
                                        `/controller/reports`,
                                        'reports'
                                    )}>
                                    {adminActivePage === 'reports' ? <MdOutlineAutoGraph /> : <MdOutlineAutoGraph />}
                                    <span>Reports</span>
                                </div>}

                            {user?.allowed_origins?.some(access => controllerCalenderTypes.flatMap(type => type.read_access).includes(access)) &&
                                <div className={adminActivePage === 'calendar' ? "menu-item active-menu" : "menu-item"}
                                    onClick={() => clickMenuItem(
                                        `/controller/calendar/month/${new Date().getFullYear()}/${new Date().getMonth() + 1}/${new Date().getDate()}`,
                                        'calendar'
                                    )}>
                                    {adminActivePage === 'calendar' ? <IoCalendarNumber /> : <IoCalendarNumberOutline />}
                                    <span>Calendar</span>
                                </div>}

                            {user?.allowed_origins?.some(access => ['slcr_reso_write'].includes(access)) &&
                                <div className={adminActivePage === 'resources' ? "menu-item active-menu" : "menu-item"}
                                    onClick={() => clickMenuItem(
                                        `/controller/resources`,
                                        'resources'
                                    )}>
                                    {adminActivePage === 'resources' ? <BiSolidBookBookmark /> : <BiBookBookmark />}
                                    <span>Resources</span>
                                </div>}

                            <div className={"menu-item exit-item"}
                                onClick={() => window.location.href = 'https://staff.alliancewatersolutions.com?page=home'}>
                                <IoMdLogOut />
                                <span>Exit</span>
                            </div>

                        </div>
                        <div className="software-info">
                            <p>@Alliance water solutions</p>
                            <p>version {ui_version}</p>
                        </div>
                    </div>
                    <div className="bottom-div">
                        <div className="profile-div">
                            <div className="image-div">
                                <img src={userProfileImage || AllianceLogo} alt='profile' />
                            </div>
                            <div className="name-div">
                                <h4>{user?.first_name} {user?.last_name}</h4>
                                <p>{user?.designation}</p>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </div >
    )
}

export default AdminPage